'use client';

import { CldImage } from 'next-cloudinary';

export default function CloudImage({
  publicId, // The Cloudinary public ID of your image
  alt,
  objectFit = 'cover',
  width, // Optional width
  height, // Optional height
  ...props
}) {
  // If both width and height are provided, use fixed dimensions;
  // otherwise default to fill mode.
  const isFixed = typeof width !== 'undefined' && typeof height !== 'undefined';
  const imageProps = isFixed ? { width, height } : { fill: true };

  return (
    <CldImage
      src={publicId}
      alt={alt}
      crop="fill"
      style={{ objectFit }}
      sizes="(max-width: 767px) 100vw, (max-width: 1200px) 50vw, 33vw"
      quality={80}
      {...imageProps}
      {...props}
    />
  );
}
